export var SearchServiceActionTypes;
(function (SearchServiceActionTypes) {
    SearchServiceActionTypes["RECEIVE_SEARCH_RESPONSE"] = "RECEIVE_SEARCH_RESPONSE";
    SearchServiceActionTypes["RECEIVE_AIRPORT_SEARCH_RESPONSE"] = "RECEIVE_AIRPORT_SEARCH_RESPONSE";
})(SearchServiceActionTypes || (SearchServiceActionTypes = {}));
